exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-dashboard[data-v-0f80f344]{height:100%;min-width:350px;overflow:auto;background-position:50%;background-repeat:no-repeat;background-size:cover}.fts-dashboard .d-actions[data-v-0f80f344]{padding:0 1rem;text-align:right}.fts-dashboard .d-container[data-v-0f80f344]{display:flex;flex-wrap:wrap;padding:0 1rem}.fts-dashboard .d-container .d-wrapper[data-v-0f80f344]{flex:1 1 350px;min-width:0;display:flex;flex-direction:column}", ""]);

// exports
